import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireActionsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    hint: {
        alignItems: "center",
        flexDirection: "row"
    },
    stretched: {
        flexBasis: "auto",
        flexShrink: 0,
        flexGrow: 1
    },
    spacer: {
        flexGrow: 1
    }
});

export const useStyles = ({
    spaces
}: QuestionnaireActionsDynamicStyleType) => {
    const styles = {
        hint: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
